// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-box-container {
  position: fixed;
  pointer-events: auto;
  z-index: 999;
}

.style-badges {
  display: flex;
  gap: 6px;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 500;
  background: #f0f0f0;
  border-radius: 4px;
  color: #555;
  white-space: nowrap;
}

.color-badge {
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.edit-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-confirm {
  background: #28a745;
  color: white;
}

.btn-confirm:hover {
  background: #218838;
}

.btn-cancel {
  background: #f0f0f0;
  color: #555;
}

.btn-cancel:hover {
  background: #e0e0e0;
}

.edit-hint {
  font-size: 11px;
  color: #999;
  margin-left: 8px;
}

.edit-box-container textarea {
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/EditBox.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".edit-box-container {\r\n  position: fixed;\r\n  pointer-events: auto;\r\n  z-index: 999;\r\n}\r\n\r\n.style-badges {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 3px 8px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  background: #f0f0f0;\r\n  border-radius: 4px;\r\n  color: #555;\r\n  white-space: nowrap;\r\n}\r\n\r\n.color-badge {\r\n  width: 20px;\r\n  height: 20px;\r\n  padding: 0;\r\n  border-radius: 4px;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.edit-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 6px 12px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.btn-confirm {\r\n  background: #28a745;\r\n  color: white;\r\n}\r\n\r\n.btn-confirm:hover {\r\n  background: #218838;\r\n}\r\n\r\n.btn-cancel {\r\n  background: #f0f0f0;\r\n  color: #555;\r\n}\r\n\r\n.btn-cancel:hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.edit-hint {\r\n  font-size: 11px;\r\n  color: #999;\r\n  margin-left: 8px;\r\n}\r\n\r\n.edit-box-container textarea {\r\n  font-family: inherit;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
